import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const OrganizationSettingsModal = ({ onSubmit, orgData, showModal }) => {
  const [orgName, setOrgName] = useState("");
  const [orgEmail, setOrgEmail] = useState("");
  const [orgPhone, setOrgPhone] = useState("");
  const [currency, setCurrency] = useState("Rs");
  const [orgAddress, setOrgAddress] = useState("");
  const [dateFormat, setDateFormat] = useState("dd/MM/yyyy");
  const [timezone, setTimezone] = useState("India");
  const [errors, setErrors] = useState({});
  const inputRef = useRef(null);
  const [contactPerson, setContactPerson] = useState("");
  const [contactDesignation, setContactDesignation] = useState("");
  const [orgType, setOrgType] = useState("Software");
  const companyid = localStorage.getItem("companyid");
  const submitButtonRef = useRef(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const dateFormats = [
    "MM/dd/yyyy",
    "dd/MM/yyyy",
    "yyyy/MM/dd",
    "MMM dd, yyyy",
    "MMMM dd, yyyy",
    "yyyy-MM-dd",
  ];


  const orgTypes = [
    "Software",
    "Emergency Services",
    "Government/Public Administration",
    "Home Improvement Services",
    "Information Technology",
    "Healthcare",
    "Education",
    "Retail",
    "Hospitality",
  ];

  const formatSampleDate = (format) => {
    const currentDate = new Date("2024-12-05");
    const options = { year: "numeric", month: "short", day: "numeric" };
    switch (format) {
      case "MM/dd/yyyy":
        return `${String(currentDate.getMonth() + 1).padStart(2, "0")}/${String(currentDate.getDate()).padStart(2, "0")}/${currentDate.getFullYear()}`;
      case "dd/MM/yyyy":
        return `${String(currentDate.getDate()).padStart(2, "0")}/${String(currentDate.getMonth() + 1).padStart(2, "0")}/${currentDate.getFullYear()}`;
      case "yyyy/MM/dd":
        return `${currentDate.getFullYear()}/${String(currentDate.getMonth() + 1).padStart(2, "0")}/${String(currentDate.getDate()).padStart(2, "0")}`;
      case "MMM dd, yyyy":
        return currentDate.toLocaleDateString("en-US", { ...options });
      case "MMMM dd, yyyy":
        return currentDate.toLocaleDateString("en-US", { ...options, month: "long" });
      case "yyyy-MM-dd":
        return `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}-${String(currentDate.getDate()).padStart(2, "0")}`;
      default:
        return format;
    }
  };

  useEffect(() => {
    if (orgData) {

      setOrgName(orgData.name || "");
      setOrgEmail(orgData.email || "");
      setOrgPhone(orgData.phone || "");
      setCurrency(orgData.company_currency || "₹");
      setOrgAddress(orgData.company_address || "");
      setDateFormat(orgData.company_date_format || "dd/MM/yyyy");
      setTimezone(orgData.timezone || "India");
      setContactPerson(orgData.contact_person || "");
      setContactDesignation(orgData.contact_designation || "");
      setOrgType(orgData.type || "Software");
    } else {
      resetFields();
    }
  }, [orgData]);

  const resetFields = () => {
    setOrgName("");
    setOrgEmail("");
    setOrgPhone("");
    setCurrency("₹");
    setOrgAddress("");
    setDateFormat("dd/MM/yyyy");
    setTimezone("India");
    setContactPerson("");
    setContactDesignation("");
    setOrgType("Software");
    setErrors({});
  };

  const validateForm = () => {
    let formErrors = {};
    if (!orgName.trim()) formErrors.orgName = "Organization Name is required";
    if (!orgEmail.trim()) formErrors.orgEmail = "Email is required";
    if (!orgPhone.trim()) formErrors.orgPhone = "Phone is required";
    if (!contactPerson.trim()) formErrors.contactPerson = "Contact person is required";
    if (!contactDesignation.trim()) formErrors.contactDesignation = "Contact designation is required";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;


    try {
      const payload = {
        company_name: orgName,
        email: orgEmail,
        phone: orgPhone,
        currency,
        location_address: orgAddress,
        dateFormat,
        timezone,
        contactperson: contactPerson,
        contactdesignation: contactDesignation,
        type: orgType,
      };

      let response;
      if (orgData) {
        response = await axios.put(`${apiUrl}/company/update/${orgData.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Organization updated successfully!");
      } else {
        response = await axios.post(`${apiUrl}/company/signup`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Organization added successfully!");
      }

     
      if (submitButtonRef.current) {
        submitButtonRef.current.click(); // Trigger the click event
      } 
      onSubmit(response.data);
      resetFields();
    } catch (error) {
      toast.error("Failed to save organization settings. Please try again.");
      console.error(error);
    }
  };

  const loadGoogleMapsScript = (callback) => {
    const scriptSrc = `https://maps.googleapis.com/maps/api/js?key=AIzaSyApehT2u7ijeKq0JJpV9A32k_7kPpKaTv0&libraries=places&language=en&region=IN`;
    if (document.querySelector(`script[src="${scriptSrc}"]`)) {
      callback();
      return;
    }
    const script = document.createElement("script");
    script.src = scriptSrc;
    script.async = true;
    script.defer = true;
    script.onload = callback;
    script.onerror = () => console.error("Failed to load Google Maps API script");
    document.body.appendChild(script);
  };

  useEffect(() => {
    if (showModal) {
      loadGoogleMapsScript(() => {
        if (window.google && window.google.maps) {
          const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
            types: ["address"],
          });
          autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if (place && place.formatted_address) {
              setOrgAddress(place.formatted_address);
            }
          });
        }
      });
    }
  }, [showModal]);

  return (
    <>
      <div className="modal custom-modal fade" id="organizationSettingsModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-lg" style={{ position: "fixed", right: 0, margin: 0, height: "100vh", width: "60%" }}>
          <div className="modal-content h-100">
            <div className="modal-header">
              <h5 className="modal-title">{orgData ? "Edit Organization" : "Add Organization"}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}>
              {/* Organization Name */}
              <div className="form-group row mb-3">
                <label className="col-md-4 col-form-label">Organization Name *</label>
                <div className="col-md-8">
                  <input
                    type="text"
                    className={`form-control ${errors.orgName ? "is-invalid" : ""}`}
                    value={orgName}
                    onChange={(e) => setOrgName(e.target.value)}
                  />
                  {errors.orgName && <div className="invalid-feedback">{errors.orgName}</div>}
                </div>
              </div>

              {/* Email */}
              <div className="form-group row mb-3">
                <label className="col-md-4 col-form-label">Email *</label>
                <div className="col-md-8">
                  <input
                    type="email"
                    className={`form-control ${errors.orgEmail ? "is-invalid" : ""}`}
                    value={orgEmail}
                    onChange={(e) => setOrgEmail(e.target.value)}
                  />
                  {errors.orgEmail && <div className="invalid-feedback">{errors.orgEmail}</div>}
                </div>
              </div>

              {/* Phone */}
              <div className="form-group row mb-3">
                <label className="col-md-4 col-form-label">Phone *</label>
                <div className="col-md-8">
                  <input
                    type="text"
                    className={`form-control ${errors.orgPhone ? "is-invalid" : ""}`}
                    value={orgPhone}
                    onChange={(e) => setOrgPhone(e.target.value)}
                  />
                  {errors.orgPhone && <div className="invalid-feedback">{errors.orgPhone}</div>}
                </div>
              </div>


           {/* Contact Person */}
           <div className="form-group row mb-3">
              <label className="col-md-4 col-form-label">Contact Person *</label>
              <div className="col-md-8">
                <input
                  type="text"
                  className={`form-control ${errors.contactPerson ? "is-invalid" : ""}`}
                  value={contactPerson}
                  onChange={(e) => setContactPerson(e.target.value)}
                />
                {errors.contactPerson && <div className="invalid-feedback">{errors.contactPerson}</div>}
              </div>
            </div>

            {/* Contact Designation */}
            <div className="form-group row mb-3">
              <label className="col-md-4 col-form-label">Contact Designation *</label>
              <div className="col-md-8">
                <input
                  type="text"
                  className={`form-control ${errors.contactDesignation ? "is-invalid" : ""}`}
                  value={contactDesignation}
                  onChange={(e) => setContactDesignation(e.target.value)}
                />
                {errors.contactDesignation && <div className="invalid-feedback">{errors.contactDesignation}</div>}
              </div>
            </div>

            {/* Organization Type */}
            <div className="form-group row mb-3">
              <label className="col-md-4 col-form-label">Type of Organization *</label>
              <div className="col-md-8">
                <select
                  className="form-control"
                  value={orgType}
                  onChange={(e) => setOrgType(e.target.value)}
                >
                  {orgTypes.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>
            </div>
              {/* Currency */}
              <div className="form-group row mb-3">
                <label className="col-md-4 col-form-label">Currency</label>
                <div className="col-md-8">
                  <select className="form-control" value={currency} onChange={(e) => setCurrency(e.target.value)}>
                    <option value="₹">₹</option>
                    <option value="Rs">Rs</option>
                    <option value="$">USD</option>
                    <option value="AUD">AUD</option>
                  </select>
                </div>
              </div>

              {/* Date Format */}
              <div className="form-group row mb-3">
                <label className="col-md-4 col-form-label">Date Format</label>
                <div className="col-md-8">
                  <select
                    className="form-control"
                    value={dateFormat}
                    onChange={(e) => setDateFormat(e.target.value)}
                  >
                    {dateFormats.map((format) => (
                      <option key={format} value={format}>
                        {format} - {formatSampleDate(format)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Timezone */}
              <div className="form-group row mb-3">
                <label className="col-md-4 col-form-label">Timezone</label>
                <div className="col-md-8">
                  <select
                    className="form-control"
                    value={timezone}
                    onChange={(e) => setTimezone(e.target.value)}
                  >
                    <option value="India">India (GMT+5:30)</option>
                    <option value="Australia">Australia (GMT+10:00)</option>
                  </select>
                </div>
              </div>

              {/* Address */}
              <div className="form-group row mb-3">
                <label className="col-md-4 col-form-label">Address</label>
                <div className="col-md-8">
                  {window.google ? (
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search for an address"
                      ref={inputRef}
                      defaultValue={orgAddress}
                      onChange={(e) => setOrgAddress(e.target.value)}
                    />
                  ) : (
                    <p>Loading address search...</p>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button type="submit" onClick={handleSubmit} className="btn btn-primary">
                Save
              </button>
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>
            </div>

            <div style={{ display: "none" }}>
        <button
          ref={submitButtonRef}
          data-bs-dismiss="modal"
          aria-label="Close"
          type="reset"
        >
          Submit2
        </button>
      </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrganizationSettingsModal;
